const NAMED = [
  ['#000000', 'Jet Black'], ['#1c1c1c', 'Onyx'], ['#36454f', 'Charcoal'], ['#555555', 'Graphite'], ['#808080', 'Steel Gray'],
  ['#a9a9a9', 'Silver Gray'], ['#d3d3d3', 'Light Gray'], ['#f5f5f5', 'Soft White'], ['#ffffff', 'Pure White'], ['#fffdd0', 'Cream'],
  ['#f5f0e6', 'Ivory'], ['#e8dcc4', 'Sand'], ['#d2b48c', 'Tan'], ['#c19a6b', 'Camel'], ['#a0522d', 'Sienna'],
  ['#7f4f24', 'Coffee Brown'], ['#5c4033', 'Dark Chocolate'], ['#3b2f2f', 'Espresso'], ['#800000', 'Maroon'], ['#8b0000', 'Deep Red'],
  ['#b22222', 'Brick Red'], ['#dc143c', 'Crimson'], ['#ff0000', 'Bright Red'], ['#ff6b6b', 'Coral Red'], ['#ff7f50', 'Coral'],
  ['#fa8072', 'Salmon'], ['#ffb6c1', 'Blush Pink'], ['#ff69b4', 'Hot Pink'], ['#e1306c', 'Raspberry'], ['#c71585', 'Magenta'],
  ['#800080', 'Royal Purple'], ['#6a0dad', 'Violet'], ['#9370db', 'Lavender Purple'], ['#e6e6fa', 'Lavender'], ['#4b0082', 'Indigo'],
  ['#191970', 'Midnight Blue'], ['#0b2545', 'Deep Navy'], ['#000080', 'Navy Blue'], ['#13315c', 'Ink Blue'], ['#1d4ed8', 'Royal Blue'],
  ['#0047ab', 'Cobalt Blue'], ['#2962ff', 'Electric Blue'], ['#4169e1', 'Bright Royal Blue'], ['#4682b4', 'Steel Blue'], ['#1e90ff', 'Sky Blue'],
  ['#0077be', 'Ocean Blue'], ['#87ceeb', 'Light Sky Blue'], ['#8da9c4', 'Dusty Blue'], ['#b0e0e6', 'Powder Blue'], ['#22d3ee', 'Aqua'],
  ['#00ced1', 'Turquoise'], ['#008080', 'Teal'], ['#005f5f', 'Deep Teal'], ['#40e0d0', 'Light Turquoise'], ['#98ff98', 'Mint'],
  ['#b7e4c7', 'Soft Mint'], ['#6bcb77', 'Fresh Green'], ['#52b788', 'Jade'], ['#2e8b57', 'Sea Green'], ['#228b22', 'Forest Green'],
  ['#2d6a4f', 'Pine Green'], ['#3a5a40', 'Hunter Green'], ['#006400', 'Deep Green'], ['#588157', 'Fern'], ['#808000', 'Olive'],
  ['#a3b18a', 'Sage'], ['#9acd32', 'Lime Green'], ['#32cd32', 'Bright Lime'], ['#dad7cd', 'Stone'], ['#ffff00', 'Bright Yellow'],
  ['#ffd93d', 'Sunshine Yellow'], ['#ffd700', 'Gold'], ['#c9a227', 'Antique Gold'], ['#daa520', 'Goldenrod'], ['#f2cc8f', 'Butterscotch'],
  ['#ffb400', 'Amber'], ['#ffa500', 'Orange'], ['#f97316', 'Burnt Orange'], ['#ff4500', 'Fiery Orange'], ['#ff3d00', 'Blaze Orange'],
  ['#f4a259', 'Apricot'], ['#cc5500', 'Rust'], ['#bc6c25', 'Copper'], ['#d4a373', 'Caramel'], ['#c97c5d', 'Terracotta'],
  ['#e2725b', 'Clay'], ['#b87333', 'Bronze'], ['#3d405b', 'Slate Indigo'], ['#0f172a', 'Midnight Slate'], ['#334155', 'Slate'],
  ['#64748b', 'Cool Gray'], ['#e2e8f0', 'Mist'], ['#eef4ed', 'Frost'], ['#f4f1de', 'Linen'], ['#6366f1', 'Periwinkle'],
  ['#6b8f71', 'Sage Green'], ['#8a9a5b', 'Moss Green'], ['#d4e8d7', 'Pale Mint'], ['#4a5d4f', 'Dusty Pine'], ['#9caf88', 'Soft Sage'], ['#b2ac88', 'Khaki Sage'],
  ['#7a6a53', 'Taupe'], ['#483c32', 'Dark Taupe'], ['#fdfdfd', 'Snow'],
];

const rgb = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));

export function colorName(hex) {
  if (!/^#[0-9a-f]{6}$/i.test(hex || '')) return '';
  const [r, g, b] = rgb(hex.toLowerCase());
  let best = '';
  let bestD = Infinity;
  for (const [h, name] of NAMED) {
    const [r2, g2, b2] = rgb(h);
    const rm = (r + r2) / 2;
    const d = (2 + rm / 256) * (r - r2) ** 2 + 4 * (g - g2) ** 2 + (2 + (255 - rm) / 256) * (b - b2) ** 2;
    if (d < bestD) { bestD = d; best = name; }
  }
  return best;
}
